import { X } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

/* 🔥 FIX MARKER ICON */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

/* 📍 CLICK LOCATION PICKER */
const LocationPicker = ({ setPosition, setPin, setAddress }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);

      try {
        const res = await axios.get(
          "https://nominatim.openstreetmap.org/reverse",
          { params: { lat, lon: lng, format: "json" } }
        );

        setPin(res.data?.address?.postcode || "");
        setAddress(res.data?.display_name || "");
      } catch (err) {
        console.log("Location fetch error");
      }
    },
  });

  return null;
};

/* 🗺 AUTO FLY */
const FlyToLocation = ({ position }) => {
  const map = useMap();

  useEffect(() => {
    map.flyTo(position, 14);
  }, [position]);

  return null;
};

/* ================= MAIN MODAL ================= */
const DeliveryLocationModal = ({ onClose, onSelectLocation }) => {
  const [position, setPosition] = useState([21.1702, 72.8311]); // Surat default
  const [pin, setPin] = useState("");
  const [address, setAddress] = useState("");

  const handleContinue = () => {
    if (!pin) return alert("Select location");

    onSelectLocation({
      address,
      pincode: pin,
      lat: position[0],
      lng: position[1],
    });

    onClose();
  };

  return (
    <div
      className="fixed inset-0 backdrop-blur-sm bg-black/20 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-4 rounded-xl w-[90%] max-w-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-semibold">Select Location</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>

        {/* MAP */}
        <MapContainer
          center={position}
          zoom={13}
          style={{ height: "300px", borderRadius: "10px" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          <LocationPicker
            setPosition={setPosition}
            setPin={setPin}
            setAddress={setAddress}
          />

          <FlyToLocation position={position} />
          <Marker position={position} />
        </MapContainer>

        {/* ADDRESS */}
        <input
          value={address}
          readOnly
          placeholder="Selected Address"
          className="w-full mt-3 p-2 border rounded-md bg-gray-50"
        />

        {/* PINCODE */}
        <input
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          placeholder="Pincode"
          className="w-full mt-2 p-2 border rounded-md"
        />

        {/* BUTTON */}
        <button
          onClick={handleContinue}
          className="w-full mt-3 bg-[#0f766e] hover:bg-[#0d5f5a] text-white py-2 rounded-md font-medium"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default DeliveryLocationModal;